import { render, staticRenderFns } from "./RandomPetsOrProjectsComponent.vue?vue&type=template&id=36347fd9&scoped=true&"
import script from "./RandomPetsOrProjectsComponent.vue?vue&type=script&lang=js&"
export * from "./RandomPetsOrProjectsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36347fd9",
  null
  
)

export default component.exports